import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClienteLogin, Menu, ClienteVAM } from '../../../views/login/cliente_login';
import { NavigationService } from "./navigation.service";
import { HandleError } from "../utils/handleError.component";
import { SessionStorageService } from "ngx-webstorage";
import { correctHeight, detectBody } from '../../../app.helpers';
import { LoginService } from '../../../views/login/login.service';

declare var jQuery: any;

@Component({
    selector: 'navigation',
    templateUrl: 'navigation.template.html',
    styleUrls: ['navigation.styles.css']
})

export class NavigationComponent implements OnInit {

    usuario: ClienteLogin;
    bandera: boolean;
    usuarioVam: ClienteVAM = new ClienteVAM();

    constructor(private loginService: LoginService, private sessionStorageService: SessionStorageService, private router: Router, private navigationService: NavigationService, private handleError: HandleError) {

    }

    ngAfterViewInit() {
        jQuery('.metismenu a').click(function () {
            setTimeout(() => {
                correctHeight();
                detectBody();
            }, 300)
        });

        jQuery('#side-menu').metisMenu();
        if (jQuery("body").hasClass("body-small")) {
            jQuery("body").toggleClass("mini-navbar");
        }
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    ngOnInit(): void {
        this.bandera = false;
        try {
            this.usuario = new ClienteLogin();
            this.usuario.Menu = new Array<Menu>();
            this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
            this.cargaTodo();
        } catch (e) {
            this.usuario = new ClienteLogin();
            this.usuario.Menu = new Array<Menu>();
            this.usuario = this.sessionStorageService.retrieve("usuario");
            this.cargaTodo();
        }
        this.sessionStorageService.observe("usuario").subscribe(a => {
            try {
                this.usuario = new ClienteLogin();
                this.usuario.Menu = new Array<Menu>();
                this.usuario = jQuery.parseJSON(a);
                this.cargaTodo();
                location.reload();
            } catch (e) {
                this.usuario = new ClienteLogin();
                this.usuario.Menu = new Array<Menu>();
                this.usuario = a;
                this.cargaTodo();
                location.reload();
            }
        });
    }

    cargaTodo() {
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            if (this.usuario != null) {
                if (this.usuario.Empresa != null) {
                    if (this.usuario.Empresa.length > 0) {
                        this.bandera = true;
                        //this.consultaMenu();
                    }
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/navigation/navigation.component.ts